<template>
	<div>
		<b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveBlindsModal" id="saveBlindsModal" :title="title" size="md" @ok="ok" @hidden="hidden" @cancel="cancel" @shown="shown" :ok-disabled="this.$store.state.ajax_in_progress">
			<div class="row">
				<div class="col-lg-12">
					
					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.description') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.project_setting_description"
								:options="currentProgress"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isProgressLoading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onProgressSearch"
								@input="updateProgress"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.project_setting_description != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDescription"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.standard') }}</label>
						</div>
						<div class="col-lg-8">
							<select class="form-control" v-model="model.standard">
								<option v-for="(value,key) in part_standard" :value="key" :key="key" selected="selected">{{value}}</option>
							</select>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.id_number') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.id_number"/>
						</div>
					</div>
					
					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.size') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.size"/>
						</div>
					</div>

					<div class="row mb-3" v-if="model.standard != null">
						<div class="col-lg-4">
							<label>{{ $t('table.rating') }}</label>
						</div>
						<div class="col-lg-8">
							<select class="form-control" v-model="model.rating">
								<option v-for="value in blind_ratings[model.standard]" :value="value" :key="value">{{value}}</option>
							</select>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.quantity') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="number" onKeyPress="if(this.value.length==6) return false;" step=".01" class="form-control" v-model="model.qty"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.measureunit') }}</label>
						</div>
						<div class="col-lg-8">
							<select class="form-control" v-model="model.unit" name="measureunit" ref="measureunit" v-validate="'required'">
								<option v-for="measure_unit in measure_units" :value="measure_unit.code" :key="measure_unit.code">{{ measure_unit.name }}</option>
							</select>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.installed') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.installed"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.removed') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.removed"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.all_installed') }}</label>
						</div>
						<div class="col-lg-8">
							<toggle-button v-model="model.all_installed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.all_removed') }}</label>
						</div>
						<div class="col-lg-8">
							<toggle-button v-model="model.all_removed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.remark') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark"/>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
	name: 'RemovedItemsModal',
	components: {
		flatPickr,
		notificationIcons,
		Multiselect,
	},
	props: {
		item: {
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		model: {
			type: Object,
			default: () => ({
				id: null,
				project_id: null,
				pressure_test_id: null,
				project_setting_id: null,
				project_setting_description: null,
				id_number: null,
				standard: null,
				size: null,
				rating: null,
				qty: null,
				unit: null,
				installed: null,
				removed: null,
				all_installed: false,
				all_removed: false,
				remark: null,
			})
		}
	},
	data() {
		return {
			isProgressLoading: false,
			currentProgress: [],
		}
	},
	mounted() {
	},
	computed: {
		measure_units: {
			get: function () {
				let measure_units = this.$store.getters.getMeasureUnits;
				return measure_units;
			}
		},
		part_standard: {
			get: function () {
				let standard = this.$store.getters.getPartStandard;
				return standard;
			}
		},
		blind_ratings: {
			get: function () {
				let rating = this.$store.getters.getBlindRatings;
				return rating;
			}
		}
	},
	watch: {
		measure_units: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
			}
		},
	},
	methods: {
		hidden(e) {
			this.$emit('hidden', e);
		},
		ok(e) {
			e.preventDefault();

			let mdl = {
				project_id: 		this.$route.params.id,
				pressure_test_id: 	this.model.pressure_test_id,
				project_setting_id: this.model.project_setting_id,
				rating:				this.model.rating,
				size:				this.model.size,
				id_number:		    this.model.id_number,
				standard:			this.model.standard,
				qty: 				this.model.qty,
				unit: 				this.model.unit,
				installed: 			this.model.installed,
				removed: 			this.model.removed,
				all_installed: 		this.model.all_installed,
				all_removed: 		this.model.all_removed,
				remark: 			this.model.remark,
			}

			Object.keys(mdl).forEach(key => {
				if (mdl[key] === '') {
					mdl[key] = null;
				}
			});
			
			var vm = this;
			if (this.model.id != null) {
				http.route("removed_item/"+this.model.id).patch(mdl, true).then(response => {
					if (!response.isError) {
						vm.$emit('onLoadTable', e);
						this.successMsg(Vue.i18n.translate('messages.removed_item_updated'));
						this.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			} else {
				http.route("removed_item").post(mdl, true).then(response => {
					if (!response.isError) {
						vm.$emit('onLoadTable', e);
						this.successMsg(Vue.i18n.translate('messages.removed_item_created'));
						this.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			}
		},
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
		cancel(e) {
			this.$emit('cancel', e);
		},
		shown(e) {
			this.errors.clear();
			this.$emit('shown', e);
		},
		show() {
			this.$refs.saveBlindsModal.show();
		},
		hide() {
			this.$refs.saveBlindsModal.hide();
		},
		clear() {
			this.model.id = null;
			this.model.project_id = null;
			this.model.pressure_test_id = null;
			this.model.project_setting_description = null;
			this.model.standard = this.part_standard.DIN;
			this.model.id_number = null;
			this.model.size = null;
			this.model.rating = null;
			this.model.qty = null;
			this.model.unit = this.measure_units.m.code;
			this.model.installed = null;
			this.model.removed = null;
			this.model.all_installed = false;
			this.model.all_removed = false;
			this.model.remark = '';
		},
		onProgressSearch(search) {
			if (search == '') {
                this.currentProgress = [];
                
                return false;
            }

			this.isProgressLoading = true;
			this.searchProgressSearch(search, this);
		},
		searchProgressSearch: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+ vm.$route.params.id + '&get_all=1&filters[type]=removed_items_description&search_select_key_and_value=' + search).get()
			data.then(response => {
				if (response.data != false) {
					vm.currentProgress = response.data;
				}
				vm.isProgressLoading = false;
			});
		}, 500),
		updateProgress(progress) {
			this.model.project_setting_id = (progress != null) ? progress.id : null;
		},
		clearSelectedDescription () {
            this.model.project_setting_description = null;
            this.model.project_setting_id          = null;
        },
	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/RemovedItemsModal.vue